module.exports = __webpack_public_path__ + "static/media/country_sl.ac85f871.webp";